import React from 'react';
import { Stack, Typography } from '@mui/material';

type Props = {
  id: string | number;
  label: string;
};

const IDOptionLabel = ({ id, label }: Props) => (
  <Stack direction='row' alignItems='center'>
    <Typography minWidth={45}>({id})</Typography>
    <Typography>{label}</Typography>
  </Stack>
);

export const getIDOptionLabel = (option: any) => {
  return typeof option === 'object' && option !== null
    ? `(${option.value}) ${option.label}`
    : '';
};

export default IDOptionLabel;
